import {
    keyframes,
    styled,
    StyledSnackbar,
    StyledText,
} from '@raskrask-dk/rr-components'

const wiggle = keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '80%': { transform: 'rotate(0deg)' },
    '85%': { transform: 'rotate(3deg)' },
    '95%': { transform: 'rotate(-3deg)' },
    '100%': { transform: 'rotate(0deg)' },
})

export const ServiceTexts = styled('div', {
    display: 'grid',
    gap: 4,
    pb: 54,

    [`& ${StyledText}`]: {
        whiteSpace: 'pre-line',
    },
})

export const CTAHelpText = styled('div', {
    bgc: '$secondary500',
    m: '-$3 -$3 $3',
    p: '$2',
    textAlign: 'center',

    [`& ${StyledText}`]: {
        animation: `${wiggle} 2.5s infinite`,
        display: 'inline-block',
    },
})

export const StyledGoToCalendar = styled('div', {
    bgc: '$primary600',
    bottom: 0,
    color: '$white',
    display: 'grid',
    gap: '$2',
    left: 0,
    p: '$3',
    position: 'fixed',
    right: 0,
    transition: '$default',
    zIndex: '$fixed',

    [`& ${StyledText}`]: {
        lineHeight: 1.1,
    },
})

export const StyledGoToServicePicker = styled('div', {
    alignItems: 'center',
    bgc: '$primary600',
    color: '$white',
    display: 'flex',
    gap: '$3',
    m: '-$3 -$3 0',
    p: '$2 $3',

    svg: {
        fontSize: 20,
    },
})

export const ServicePicker = styled('div', {
    alignContent: 'start',
    display: 'grid',
    gap: '$3',
})

export const StyledCalender = styled('div', {
    [`& ${StyledSnackbar}`]: {
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        right: 'auto',
        top: '10%',
        bottom: 'auto',
        animation: 'none',
    },
})
